import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const IMG_BASE = '/images/Feb18ServerSideRefactorImages/HotScams';

const CatfishingLearnMorePage = () => {
  const navigate = useNavigate();

  const allDigitalScamLinks = [
    { label: 'Phishing \\ Smishing \\ Spoofing', path: '/dashboard/phishing-learn-more' },
    { label: 'Tech Support', path: '/dashboard/tech-support-learn-more' },
    { label: 'Lottery, sweepstake', path: '/dashboard/lottery-sweepstake-learn-more' },
    { label: 'Law enforcement Impersonation', path: '/dashboard/law-enforcement-impersonation-learn-more' },
    { label: 'Government Impersonation', path: '/dashboard/government-impersonation-learn-more' },
    { label: 'Work From Home', path: '/dashboard/work-from-home-learn-more' },
    { label: 'Grandparent', path: '/dashboard/grandparent-learn-more' },
    { label: 'Crypto ATM', path: '/dashboard/crypto-atm-learn-more' },
    { label: 'Funeral', path: '/dashboard/funeral-learn-more' },
  ];

  const allConfidenceScamLinks = [
    { label: 'Pig Butcher ( Crypto )', path: '/dashboard/cryptocurrency-learn-more' },
    { label: 'Catfishing ( Romance )', path: '/dashboard/catfishing-learn-more' },
  ];

  const psaVideos = [
    'Abused in Salt Lake City',
    'No good deed ( Charity)',
    '$700,000– Price of Love',
    'Can happen to me',
    'Scam Red Flags',
    'Scam Red Flags',
    'Grandparent',
    'Grandparent',
    'Tech Support',
    'Phantom Hacker',
  ];

  const darkPsychLinks = [
    { label: 'Pig Butchering ( Crypto ) Assessment', path: '/dashboard/pig-butchering-crypto' },
    { label: 'Catfishing ( Romance ) Assessment', path: '/dashboard/catfishing-romance' },
    { label: 'Day After', path: '/dashboard/the-day-after' },
  ];

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* Spacer */}
        <div className="pt-6" />

        {/* 1. Hero — Split layout: Pink title card + Image (33% / 67%) */}
        <div className="px-12 pt-2 pb-6">
          <div className="flex gap-4" style={{ height: '256px' }}>
            <div className="bg-pink-300 flex items-center px-10" style={{ width: '33%' }}>
              <h1 className="text-4xl font-bold text-white leading-tight">
                Catfishing -<br />Romance
              </h1>
            </div>
            <img
              src={`${IMG_BASE}/HotScamsCatfishHero.jpeg`}
              alt="Catfishing Romance"
              className="h-full object-cover"
              style={{ width: '67%' }}
            />
          </div>
        </div>

        {/* 2. What you need to know */}
        <div className="px-12 py-6">
          <h2 className="text-2xl font-bold text-black mb-4">What you need to know</h2>
          <p className="text-black leading-relaxed mb-4">
            Your online acquaintance is the soulmate you've been searching for, or perhaps, they're a romance scammer and you're the next target.
          </p>
          <p className="text-black leading-relaxed mb-4">
            All scams are bad; however, romance scams are particularly hideous because they deal with the heart. Scammers use the abuse playbook to toy with people's emotions in a cruel and callus fashion. From fake social media profiles, stolen images, bogus professions, it's all designed to create the illusion you've found - Mr., Mrs. Miss Amazing.
          </p>
          <p className="text-black leading-relaxed mb-4">
            They are eager to learn about your hopes, dreams and lavish you with attention. Their job is gaining access to your bank account, retirement or other investments and drain it dry leaving you – bankrupt and financially destitute.
          </p>
          <p className="text-black leading-relaxed mb-4">
            These abusers use a tried-in-true grooming playbook to access, befriend, and exploit their victims. While grooming can take many forms, there are certain blinking red light indicators of abuse that are early warning signs indicating financial, emotional and physical despair.
          </p>
          <p className="text-black leading-relaxed mb-4">
            Ann was swindled out of $250,000 creating family hardship:
          </p>
          <ul className="list-disc pl-6 space-y-2 text-black text-sm mb-4">
            <li>Started with a friend request on Facebook.</li>
            <li>Daily morning chats over coffee sharing each other's aspiration.</li>
            <li>Coached in criminal activity - money laundering.</li>
            <li>Became isolated and secretive about the relation.</li>
            <li>When the money was gone, so was the morning chats over coffee.</li>
          </ul>
        </div>

        {/* Personal Safety */}
        <div className="px-12 pb-6">
          <h2 className="text-xl font-bold text-black mb-2">Personal safety</h2>
          <p className="text-black leading-relaxed">
            Call the police immediately if you feel there is a danger to yourself or a loved one
          </p>
        </div>

        {/* 3. Three info cards — Victim Impact, Warning Signs, Attach Method */}
        <div className="px-12 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* 01. Victim Impact */}
            <div className="text-white p-6 border-l-4" style={{ backgroundColor: '#000000', borderColor: '#808080' }}>
              <h3 className="text-lg font-bold mb-4">01. Victim Impact</h3>
              <p className="text-sm mb-1">. 17,910 victims</p>
              <p className="text-sm mb-3">. $642 Million stolen</p>
              <p className="text-xs text-gray-400 mt-4">
                Source → FBI \\ IC3 2024 IC3 Annual Report
              </p>
            </div>

            {/* 02. Warning Signs */}
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">02. Warning Signs</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Harmless unsolicited text message with subjects - 'hi', 'how are you?', 'how the weather', 'we met'.</li>
                <li>Quick emotional attachment ( Love booms). Encouraged to join an investing group.</li>
                <li>Discussion of financial or emotional distress. Huge returns with minimal risk.</li>
                <li>Tiered plans with minimum investment amounts.</li>
                <li>Uses WhatsApp \\ WeChat \\ Telegram or other encrypted messaging apps for investing.</li>
                <li>Highly polished LinkedIn or social profiles to create the illusion of legitimacy.</li>
              </ul>
            </div>

            {/* 03. Attach Method */}
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">03. Attach Method</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Calls \\ DM (texting) \\ Email \\ pop up messages \\ Fake website</li>
                <li>Instagram \\ Facebook \\ LinkedIn \\ X (Twitter), TikTok</li>
                <li>Online Dating Site</li>
                <li>Deepfake (image \\ voice \\ video)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 03. Prevention Tips */}
        <div className="px-12 py-4">
          <div className="py-8 px-12 border-l-4" style={{ backgroundColor: '#35759C', borderColor: '#ADC9E9' }}>
            <h3 className="text-lg font-bold text-white mb-4">03. Prevention Tips</h3>
            <ul className="space-y-2 text-white text-sm leading-relaxed">
              <li>- Perform a Reverse Image Search</li>
              <li>- Never share intimate photos or send money.</li>
              <li>- Speed = Danger</li>
              <li>- Understand Dark Psychological techniques</li>
            </ul>
          </div>
        </div>

        {/* 04. Dark Psychological */}
        <div className="px-12 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            <div>
              <img
                src={`${IMG_BASE}/HotScamsCatfishingMidPageAsset.jpeg`}
                alt="Dark Psychological"
                className="object-cover w-full h-full"
              />
            </div>
            <div className="p-8 flex flex-col justify-center border-l-4" style={{ backgroundColor: '#BCE3A5', borderColor: '#65A542' }}>
              <h3 className="text-xl font-bold text-black mb-4">04. Dark Psychological</h3>
              <p className="text-black text-sm leading-relaxed mb-6">
                Discover how scammers use these emotional behavioral techniques and interaction patterns to lure, exploit and control their victims.
              </p>
              <div className="space-y-2">
                {darkPsychLinks.map((link, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(link.path)}
                    className="block text-sm text-black font-medium hover:text-blue-600 cursor-pointer"
                  >
                    → {link.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Take the Catfishing Assessment CTA */}
        <div className="px-12 pb-6">
          <div
            className="relative w-full overflow-hidden"
            style={{ minHeight: '220px' }}
          >
            <img
              src={`${IMG_BASE}/HotScamsCatfishingStartAssessmentButtonBackgroundImage.jpeg`}
              alt="Catfishing Assessment"
              className="absolute inset-0 w-full h-full"
              style={{ objectFit: 'fill' }}
            />
            <div className="relative flex flex-col justify-center items-start h-full px-10 py-10" style={{ minHeight: '220px' }}>
              <h3 className="text-4xl font-bold text-black mb-6">
                Take the Catfishing<br />Assessment
              </h3>
              <button
                onClick={() => navigate('/dashboard/catfishing-romance')}
                className="px-36 py-4 bg-white text-black text-base font-semibold rounded-md border border-black hover:bg-gray-100 hover:shadow-lg transition-all"
              >
                Start
              </button>
            </div>
          </div>
        </div>

        {/* 05. FBI PSA Videos */}
        <div className="px-12 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            <div className="p-6 border-l-4" style={{ backgroundColor: '#ADC9E9', borderColor: '#2E5F7F' }}>
              <h3 className="text-xl font-bold text-white mb-4">05. FBI PSA Videos</h3>
              <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-6">
                {psaVideos.map((title, idx) => (
                  <p key={idx} className="text-sm text-white">{title}</p>
                ))}
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => navigate('/dashboard/av-library/fbi-ic3')}
                  className="px-12 py-3 bg-white text-black text-sm font-medium hover:bg-gray-200 transition-colors"
                >
                  Watch videos
                </button>
              </div>
            </div>
            <div>
              <img
                src={`${IMG_BASE}/HotScamsImageToTheRightOf05FBIVideosNonAssessmentPages.jpeg`}
                alt="FBI PSA"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* Category Footer — Know more / Digital Scams / Confidence Scams */}
        <div className="px-12 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden">
            <div className="p-8" style={{ backgroundColor: '#CA74C7' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Know more</h3>
            </div>
            <div className="p-8" style={{ backgroundColor: '#6093D4' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Digital Scams</h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                {allDigitalScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="p-8" style={{ backgroundColor: '#4B7C30' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Confidence Scams</h3>
              <div className="space-y-1">
                {allConfidenceScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="block text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default CatfishingLearnMorePage;
